export default __webpack_public_path__ + "static/media/texture.b6756b2a.png";